<template>
    <div>
        <public-title>导游管理
            <span class="text-link ml-auto" @click="$router.push({name:'GuidesManage',query:{tab:$route.query.flag-1}})" slot="right">返回上一页</span>
        </public-title>
        <h4 class="bg-base p-3 text-left">导游信息</h4>
        <div class="pt-3 pb-3 pl-2 pr-2 bg-white">
            <!-- <div class="mt-3 d-center-start"><left-text leftText="导游名称"/>{{StoreBasicInfo.truename}}</div> -->
            <div class="mt-3 d-center-start"><left-text leftText="导游名称"/>{{StoreBasicInfo.title}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="性别"/> {{StoreBasicInfo.sex | formatVar('sex')}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="所在机构"/>{{StoreBasicInfo.institution||'无'}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="从业年限"/>{{StoreBasicInfo.work_seniority}}年</div>
            <div class="mt-3 d-center-start"><left-text leftText="身份证号"/>{{StoreBasicInfo.id_card||'无'}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="手机号"/>{{StoreBasicInfo.mob}}</div>
            <!-- <div class="mt-3 d-center-start"><left-text leftText="联系地址"/>{{StoreBasicInfo.province_name}} / {{StoreBasicInfo.city_name}} / {{StoreBasicInfo.district_name}} / {{StoreBasicInfo.address}}</div> -->
            <!-- <div class="mt-3 d-center-start"><left-text leftText="语种"/>{{StoreBasicInfo.language}}</div> -->
            <div class="mt-3 d-center-start"><left-text leftText="导游证号"/>{{StoreBasicInfo.guide_num||'无'}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="导游证"/>
                
                <img class="rounded cursor-pointer" v-lazy="ImgPreUrl + StoreBasicInfo.guide_pic" width="150" height="150" v-if="StoreBasicInfo.guide_pic"/>
                <img  class="rounded cursor-pointer" src="/images/public/defaultImgSmall.png" width="150" height="150"  v-else> 
            </div>
            <div class="mt-2 mb-5 d-center-start"><left-text leftText="带团经历"/>{{StoreBasicInfo.lead_experience||'无'}}</div>
        </div>
    </div>
</template>

<script>
import {mapState,mapGetters} from 'vuex'
export default {
   name: 'GuideMsg',
   data () {
       return {
           StoreBasicInfo: ''
       }
   },
   computed: {
        ...mapState(['userLoginMessage']),
        ...mapGetters(['storeInfo','isGroup'])
   },
   created () { this.getGuideInfo() },
   methods: {
        async getGuideInfo () {
            let url="";
             switch (this.$route.query.flag*1) {
                    case 1:url='/pc/Travel/GuideDetail';break;   //添加新人
                    case 2:url='/pc/Travel/LeaderDetail';break;  //添加领队
                    default:
                        url='/pc/Travel/GuideDetail';
                    break;
            }
            let resData = await this.$axios.post(url, {
                store_id: this.isGroup ? this.$route.query.store : this.storeInfo.storeId,
                id: this.$route.query.id
            });
            if (resData.code === '00000') {
                this.StoreBasicInfo = resData.data.info;
            }
        }
   }
}
</script>

<style lang="scss" scoped>
.bg-base{
    background-color: #fcfcfc!important
}
</style>